import { createControlId } from '@avantia/questionset-model';

import { HpControlValueTypes } from '../../../types';

export interface HpBasicReadOnlyTextControlProps {
  id: string;
  value: HpControlValueTypes;
}

export function BasicReadOnlyTextControl({ id, value }: HpBasicReadOnlyTextControlProps): JSX.Element {
  return <span id={createControlId({ questionId: id })}>{value as string}</span>;
}
